import { motion } from 'framer-motion';
import { MapPin, ExternalLink } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const VenuePage = () => {
  const { t } = useLanguage();

  return (
    <section className="pt-14 pb-16 bg-white" data-testid="venue-page">
      <div className="max-w-5xl lg:max-w-6xl mx-auto px-6">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h1 className="font-serif text-4xl sm:text-5xl text-[#2D2A26] mb-4">
            {t('venueTitle')}
          </h1>
          <div className="w-12 h-0.5 bg-[#B5985A] mx-auto" />
        </motion.div>

        {/* Side-by-side: Photo + Details */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex flex-col md:flex-row md:items-start gap-12 lg:gap-16"
        >
          {/* Photo */}
          <div className="md:w-[55%] lg:w-[65%] flex-shrink-0 overflow-hidden rounded-3xl">
            <img
              src="/images/chateau-grounds.jpg"
              alt="Château des Joncherets and its grounds reflected in the pond"
              className="w-full h-[12rem] md:h-[28rem] lg:h-[32rem] object-cover"
              data-testid="venue-photo"
            />
          </div>

          {/* Details */}
          <div className="flex-1 flex flex-col justify-center">
            <h2 className="font-serif text-2xl text-[#2D2A26] mb-4">
              Château des Joncherets
            </h2>

            <p className="text-[#666] leading-relaxed mb-6">
              {t('venueDescription')}
            </p>

            <p className="text-[#666] leading-relaxed mb-6">
              {t('venueHistory')}
            </p>

            <div className="border-t border-[#E5E5E5] pt-6 mt-2">
              <div className="flex items-center gap-3 mb-1">
                <MapPin className="w-4 h-4 text-[#B5985A] flex-shrink-0" />
                <p className="text-[#666] text-sm leading-snug">
                  8 Rue du 8 Mai 1945 · 28350 Saint-Lubin-des-Joncherets, France
                </p>
              </div>
              <div className="pl-7 pt-2 flex gap-4">
                <a
                  href="https://maps.app.goo.gl/z7hrMH7TZXjG6Dbv7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-[#B5985A] text-sm hover:text-[#9A7F48] transition-colors"
                  data-testid="venue-map-link"
                >
                  Google Maps
                  <ExternalLink className="w-3 h-3" />
                </a>
                <span className="text-[#DDD]">|</span>
                <a
                  href="https://www.joncherets.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-[#B5985A] text-sm hover:text-[#9A7F48] transition-colors"
                  data-testid="venue-website-link"
                >
                  {t('venueWebsite')}
                  <ExternalLink className="w-3 h-3" />
                </a>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
